var exports = {
  "R": "csvFilter__7qCFnA",
  "D": "csvTable__OA4k7n",
};

module.exports = exports;
